import React, { useEffect, useState } from "react";
import { Card, CardBody, Row, CardTitle, Spinner } from "reactstrap";
import DonutChart from "./DonutChart";
import api from '../../utils/api';

const MonthlyEarnings = () => {
  const [counts, setCounts] = useState({
    institutions: 0,
    journalists: 0,
    activists: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCounts = async () => {
      try {
        const [instRes, journRes, actRes] = await Promise.all([
          api.get("/institutions/count/total"),
          api.get("/journalists/count/total"),
          api.get("/activists/count/total"),
        ]);

        setCounts({
          institutions: instRes.data.count || 0,
          journalists: journRes.data.count || 0,
          activists: actRes.data.count || 0,
        });
      } catch (error) {
        console.error("Error fetching total stats:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCounts();
  }, []);

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <CardTitle className="h4 mb-4">الإحصائيات الإجمالية</CardTitle>

          {loading ? (
            <div className="text-center">
              <Spinner color="primary" />
            </div>
          ) : (
            <>
              <Row className="text-center mt-4">
                <div className="col-4">
                  <h5 className="font-size-20">{counts.institutions}</h5>
                  <p className="text-muted">المؤسسات</p>
                </div>
                <div className="col-4">
                  <h5 className="font-size-20">{counts.journalists}</h5>
                  <p className="text-muted">الصحفيين</p>
                </div>
                <div className="col-4">
                  <h5 className="font-size-20">{counts.activists}</h5>
                  <p className="text-muted">الناشطين</p>
                </div>
              </Row>
              <div dir="ltr">
                <DonutChart data={counts} />
              </div>
            </>
          )}
        </CardBody>
      </Card>
    </React.Fragment>
  );
};

export default MonthlyEarnings;
